import React from 'react';
import {Platform, View} from 'react-native';

import {ProfileActiveAttribute} from '/component/base/ProfileActiveAttribute';
import {ProfilePage} from '/constant/TestIDs';

import {ContactSupport} from './ContactSupport';
import {useFeedbackSection} from './FeedbackSection.hook';
import {styles} from './FeedbackSection.style';
import {FeedbackSectionProps} from './FeedbackSection.types';

export const FeedbackSection = ({
  onFeedbackPress = () => {},
}: FeedbackSectionProps) => {
  const {tt, showReleaseNotes, featureFlag} = useFeedbackSection({
    onFeedbackPress,
  });
  const showWhatsNew = Platform.OS !== 'web';
  const showContactSupport =
    Platform.OS !== 'web' && !!featureFlag?.showContactSupport;

  if (!showWhatsNew && !showContactSupport) {
    return null;
  }

  return (
    <View style={styles.base}>
      {showContactSupport && <ContactSupport />}
      {/*  --- Qualtrics survey temporarily disabled for accessibility compliance ---
     <ProfileActiveAttribute
        ref={shareFeedbackRef}
        testID={ProfilePage.profileFeedback}
        iconName={'megaphone'}
        label={tt('shareFeedback', 'Share feedback')}
        onPress={onShareFeedback}
      /> */}
      {showWhatsNew && (
        <ProfileActiveAttribute
          testID={ProfilePage.profileWhatsNew}
          iconName={'newest'}
          label={tt('whatsNew', 'What’s New')}
          onPress={showReleaseNotes}
          isLastElement={true}
        />
      )}
      {/*<ProfileActiveAttribute
        style={{base: styles.helpAttribute, arrowIcon: styles.arrowIcon}}
        iconName={'help'}
        label={'Help & Support'}
        isLastElement={true}
      />*/}
    </View>
  );
};
